module.exports = __webpack_public_path__ + "static/media/onoiwa-extra-3.17f346bd.png";